import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useRef, useState } from 'react';
import Select, { StylesConfig } from "react-select";
import { toast } from 'react-toastify';
import TextField from '../../../../../core/common/textFields/TextField';
import { useGetPaymentScheduleAddendaByIdQuery } from '../../../../../services/EndPointsApis';
import { initialValuesPaymentSchedule } from '../../../Projects/SaleWizardData/InitialValuesSalesWizard';
import FormattedNumber from "../../../../../core/common/textFields/FormatNumber";
import { DatePicker } from "antd";
import { svgIcons } from "../../../../../style/fonts/SvgIcons";
import DateComp from "../../../../../core/common/dateComponent/DateComp";
import DateTimeComp from "../../../../../core/common/dateComponent/DateTimeComp";


const PaymentScheduleAddenda = ({ formik, statusOfAddenda, setPaymentScheduleLoading, viewOnly, isReviewed, isApproved, isEditing, addendaData, amountPaybaleChange, setAmountPaybaleChange, IsPaymentScheduleTrigger, salePriceAddendaPrice, selectedAddendaId, setRemainingAmount, remainingAmount, formikAddenda, getallActiveUsers, setSaleInfoData, projectId, projectLookups, setTotalAmount, totalAddendaSaleAmt }: any) => {

  const [paymentType, setPaymentType] = useState({ id: 0, value: "" });
  const [paymentAmt, setPaymentAmt] = useState("");
  const [customOnChange, setCustomOnChange] = useState<{ [key: number]: string }>({});
  const handleCustomChange = (index: number, value: string) => {
    setCustomOnChange((prev) => ({
      ...prev,
      [index]: value,  // keep as raw string
    }));
  };


  const [totalPaymentDistribution, setTotalPaymentDistribution] = useState(0);
  const [amountPayableUpAccep, setamountPayableUpAccep] = useState(0);
  const [amountPaybalecheck, setAmountPaybalecheck] = useState(false)
  const [amountpayableInUseEffect, setAmountpayableInUseEffect] = useState([])
  const [isSecondUseffectRun, setisSecondUseffectRun] = useState(false)
  const lastAddedEntry = useRef<any>(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [formatedRemainingAmount, setFormatedRemainingAmount] = useState(0)

  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };
  dayjs.extend(customParseFormat);
  //Get Sale Info
  const { data: saleInfoData, refetch, isFetching, isLoading, isSuccess } = useGetPaymentScheduleAddendaByIdQuery({ ProjectId: projectId, AddendaId: selectedAddendaId || "00000000-0000-0000-0000-000000000000" })

  useEffect(() => {
    refetch()
  }, [])

  useEffect(() => {
    if (isLoading) {
      setPaymentScheduleLoading(true)
    }
    if (isSuccess) {
      setPaymentScheduleLoading(false)

    }
  }, [isLoading, isSuccess])
  // const maxOrderId = formik?.values?.length ? Math.max(...formik?.values?.map((item: { orderId: any; }) => item?.orderId)) : 0;
  type OptionType = {
    label: string;
    value: number;
  };

  const maxOrderId = formik?.values?.length
    ? Math.max(...formik?.values?.map((item: any) => item.orderId + 1))
    : 0;

  const optionsOrderId: OptionType[] = Array.from({ length: maxOrderId }, (_, i) => ({
    label: `${i + 1}`,
    value: i + 1,
  }));

  const formatNumber = (value: any) =>
    value ? Number(value).toFixed(2) : "0";


  const totalContractAmount = salePriceAddendaPrice?.salePrice + salePriceAddendaPrice?.addendaPrice || 0;
  const totalContractInApproved = statusOfAddenda === "Approved" ? salePriceAddendaPrice?.salePrice + salePriceAddendaPrice?.addendaPrice : 0

  const { resetForm } = formik;
  //GetSaleInfoById

  // useEffect(() => {
  //     if (!formik.values.projectPaymentSchedule?.length && saleInfoData?.result?.projectPaymentSchedule) {
  //         formik.setValues({
  //             ...formik.values,
  //             projectPaymentSchedule: saleInfoData.result.projectPaymentSchedule.map((item: any) => ({
  //                 ...item,
  //                 newAmount: item.newAmount || 0,
  //             })),
  //         });
  //     }
  // }, [saleInfoData]);

  // useEffect(() => {
  //   refetch()
  // }, []);




  // useEffect(() => {

  //   setamountPayableUpAccep(parseFloat(formikAddenda.values.amtPayableAcceptance) || 0)

  // }, [formikAddenda.values])

  const handleDateChange = (date: Dayjs | null) => {
    // setSelectedFreshAptDate(date);
    formik.setFieldValue('saleDate', date ? date.format('YYYY-MM-DD') : null);
  };

  const formatComma = (num: number | string) => {
    if (num === null || num === undefined) return "0.0";
    const numericValue = String(num).replace(/,/g, "");
    if (isNaN(Number(numericValue))) return String(num);
    return Number(numericValue).toLocaleString();
  };

  useEffect(() => {
    const total = formik?.values?.reduce(
      (sum: number, item: typeof initialValuesPaymentSchedule[0]) => sum + (item?.newAmount || 0),
      0
    );
    setTotalPaymentDistribution(total)
    const totalContractAmountNum = Number(totalContractInApproved) || 0;
    const saleAmountNum = Number(formikAddenda?.values?.saleAmount) || 0;
    const totalNum = Number(total) || 0;
    const remaining = (totalContractAmount + saleAmountNum) - totalNum;
    const remainingApproved = totalContractAmountNum - totalNum;

    const remainingFormatted = new Intl.NumberFormat("en-US").format(
      isNaN(remaining) ? 0.00 : remaining
    );
    const remainingFormattedApproved = new Intl.NumberFormat("en-US").format(
      isNaN(remainingApproved) ? 0.00 : remainingApproved
    );
    if (statusOfAddenda === "Approved") {
      setRemainingAmount(remainingFormattedApproved);
      setFormatedRemainingAmount(remainingApproved)

    } else {
      setRemainingAmount(remainingFormatted);
      setFormatedRemainingAmount(remaining)

    }
  }, [formik.values, formikAddenda?.values?.saleAmount, totalContractAmount]);
  //use for dynamic desription in nweEntry am creating in handleTableChange , when the payment type is other 
  const [paymentDescription, setPaymentDescription] = useState("");
  const [concatPaymentDescription, setConcatPaymentDescription] = useState("");
  const [paymentDate, setPaymentDate] = useState<Dayjs | null>(null);

  const handleTableChange = () => {
    if (!paymentType.id || !paymentAmt || (paymentType?.id === 13 && !paymentDescription) || (paymentType.id === 12 && ((!paymentDate || !paymentDate?.isValid?.()) || !paymentDescription)) || parseFloat(paymentAmt) === 0) {
      toast.error('Please fill all the fields.');
      return;
    }

    const maxOrderId = formik.values.reduce(
      (max: number, entry: any) => Math.max(max, entry.orderId || 0),
      0
    );

    const newOrderId = maxOrderId + 1;

    // Create a new payment entry
    const newEntry = {
      id: "00000000-0000-0000-0000-000000000000",
      projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      orderId: newOrderId,
      addendaNbr: null,
      childId: null,
      // lst_PaymentType: paymentType,
      lst_PaymentType: paymentType.value === "Other"
        ? {
          ...paymentType,
          value: `Other - ${paymentDescription}`
        }
        : paymentType.value === "On Date"
          ? {
            ...paymentType,
            value: `On Date - ${concatPaymentDescription}`
          } : paymentType,

      paymentAmt: 0,
      newAmount: parseFloat(paymentAmt),
      changeBy: paymentAmt || 0,
      lst_CreatedBy: { id: 0, value: "" },
      lst_Modified: { id: 0, value: "" },
      createdDT: new Date().toISOString(),
      modifiedDT: new Date().toISOString(),
      ...(paymentType?.value === "Other" && { description: paymentDescription }),
      ...(paymentType?.value === "On Date" && {
        description: concatPaymentDescription,
      }),
    };

    // Update Formik values
    const filteredSchedule = formik.values?.filter(
      (entry: any) => entry.id !== "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    );
    const updatedValues = [...filteredSchedule, newEntry];
    formik.setValues(updatedValues);

    // Reset form inputs
    setPaymentType({ id: 0, value: "" });
    setPaymentAmt("");
    setPaymentDescription("");
    setConcatPaymentDescription("");
    setPaymentDate(null)
  };

  // useefect to handle payment schedule of addenda 
  // the first useeffect  first condition isSecondUseeefectRun is a state, that becomes true in the second check of the second useeffect this state is used so that the first check of the first useefect didnot run again after my second condidition of second useeefect 
  // isPaymentScheduleTrigger is a prop that passes from the parent component , it is in the sidebarAddenda and is becoming true in dirrent check which are related to stepper , like on handleNext , and handleBack , it tracks the user go back or not 
  //amountpayable change is the prop and also state which is coming from the createAddendum check that if the amount of the upon acceptance field changes or not 
  // because if the user go back and then go next the useeffect runs again the first and second both and some values become change because the api hits again and again data set to formik so i make check the data didnot set to formik if amount didnot change
  //on edit view the first useefect will runs only becuase second useeffect is for upon acceptance field and this field is diabled in edit view 

  useEffect(() => {
    if (isSecondUseffectRun === false && IsPaymentScheduleTrigger === false && saleInfoData?.result && Object.keys(saleInfoData?.result).length > 0) {
      formik.setValues(saleInfoData?.result);
      setAmountPaybalecheck(true)
    }
    else if (IsPaymentScheduleTrigger === true) {
      setAmountPaybalecheck(true)
    }
    // else if (isEditing === true && IsPaymentScheduleTrigger === false) {
    //   formik.setValues(saleInfoData?.result);
    // }

  }, [IsPaymentScheduleTrigger, isFetching, amountPaybaleChange]);


  // this useefect is specially for the upon acceptance field , which i add in the payment schedule of addenda , if we put value in it in the create Addendum it will be added to payment schedule 
  // if there is no value added in it at first there will be no payment for upon acceptance added 
  // if user add value and then go next and then go back and remove it it should be remove too 
  // this useeffect is also dependent on the first useefect because we are setting the api values to  formik in the first useeffect 
  //amountPaybalecheck this state confirms the first useefect rus correctly with its checks 
  //amountPaybaleChange it checks the amount change or not ,, because if the user go back and then go next the useeffect runs again the first and second both and some values become change because the api hits again and again data set to formik so i make check the data didnot set to formik if amount didnot change 
  //on edit view the first useefect will runs only becuase second useeffect is for upon acceptance field and this field is diabled in edit view 

  // useEffect(() => {

  //   const payableAmount = formikAddenda.values.amtPayableAcceptance || '0'
  //   if (isEditing) {
  //     return
  //   }
  //   // Case 1: If amount is 0, remove any current addendum items
  //   if ((!payableAmount || payableAmount === '' ||
  //     payableAmount === '0') && !isEditing) {
  //     formik.setValues((prevValues: any[]) => {
  //       const updatedValues = prevValues?.filter((item: any) => {
  //         const isCurrentAddendum = item?.lst_PaymentType?.value?.includes("Current Addendum");
  //         return !isCurrentAddendum;
  //       });

  //       return [
  //         ...updatedValues,
  //       ]
  //     });

  //     return;
  //   }

  //   // Case 2: Non-zero amount, add or replace current addendum item
  //   if ((payableAmount !== '' || payableAmount !== '0') && amountPaybalecheck === true && amountPaybaleChange === true) {
  //     formik.setValues((prevValues: any[]) => {
  //       const updatedValues = prevValues?.filter((item: any) => {
  //         const isCurrentAddendum = item?.lst_PaymentType?.value?.includes("Current Addendum");
  //         return !isCurrentAddendum;
  //       });
  //       const newItem = {
  //         projectId: prevValues[0]?.projectId || "",
  //         childId: addendaData?.result?.addendaId || null,
  //         orderId: updatedValues.length + 1,
  //         lst_PaymentType: {
  //           id: 14,
  //           value: `Upon Addenda Acceptance (${formikAddenda.values.addendaNbr?.includes("FLD")
  //             ? "Current Addendum"
  //             : formikAddenda.values.addendaNbr || "Current Addendum"
  //             })`,
  //         },
  //         id: "00000000-0000-0000-0000-000000000000",
  //         // paymentAmt: payableAmount,
  //         changeBy: payableAmount || 0,
  //         paymentAmt: 0,
  //         newAmount: payableAmount,
  //         lst_CreatedBy: prevValues[0]?.lst_CreatedBy || { id: null, value: "" },
  //         lst_Modified: { id: null, value: " " },
  //         createdDT: new Date().toISOString(),
  //         modifiedDT: new Date().toISOString(),
  //       };

  //       updatedValues.push(newItem);
  //       return updatedValues;

  //     });

  //     setAmountPaybaleChange(false);
  //     setisSecondUseffectRun(true)
  //   }

  // }, [
  //   formikAddenda.values.amtPayableAcceptance,
  //   formikAddenda.values,
  //   amountPaybalecheck,
  //   amountPaybaleChange,
  // ]);

  useEffect(() => {
    const payableAmount = formikAddenda.values.amtPayableAcceptance || '0';
    // if (isEditing) return;

    // Case 1: If amount is 0, remove any current addendum items ( it is for create view)
    if ((!payableAmount || payableAmount === '' ||
      payableAmount === '0') && !isEditing) {
      formik.setValues((prevValues: any[]) => {
        const updatedValues = prevValues?.filter((item: any) => {
          const isCurrentAddendum = item?.lst_PaymentType?.value?.includes("Current Addendum");
          return !isCurrentAddendum;
        });

        return [
          ...updatedValues,
        ]
      });

      return;
    }
    // Case 1: If amount is 0, remove any current addendum items ( it is for edit view)

    if ((!payableAmount || payableAmount === '' ||
      payableAmount === '0') && isEditing) {
      formik.setValues((prevValues: any[]) => {
        const updatedValues = prevValues?.filter((item: any) => {
          const isCurrentAddendum = item?.lst_PaymentType?.value?.includes(formikAddenda.values.addendaNbr);
          return !isCurrentAddendum;
        });

        return [
          ...updatedValues,
        ]
      });

      return;
    }

    // Case 2: Non-zero amount, update or add "Current Addendum" item ( it is for create view)
    if ((payableAmount !== '' && payableAmount !== '0') && amountPaybalecheck && amountPaybaleChange && !isEditing) {
      formik.setValues((prevValues: any[]) => {
        const updatedValues = [...prevValues]; // clone to avoid mutating state directly

        const existingIndex = updatedValues.findIndex((item: any) =>
          item?.lst_PaymentType?.value?.includes("Current Addendum")
        );

        const newItem = {
          ...(updatedValues[existingIndex] || {}), // preserve existing values if any
          projectId: prevValues[0]?.projectId || "",
          childId: addendaData?.result?.addendaId || null,
          orderId: (existingIndex !== -1
            ? updatedValues[existingIndex]?.orderId
            : updatedValues.length + 1),
          lst_PaymentType: {
            id: 14,
            value: `Upon Addenda Acceptance (${formikAddenda.values.addendaNbr?.includes("FLD")
              ? "Current Addendum"
              : formikAddenda.values.addendaNbr || "Current Addendum"
              })`,
          },
          id: "00000000-0000-0000-0000-000000000000",
          changeBy: payableAmount || 0,
          paymentAmt: 0,
          newAmount: payableAmount,
          lst_CreatedBy: prevValues[0]?.lst_CreatedBy || { id: null, value: "" },
          lst_Modified: { id: null, value: " " },
          createdDT: new Date().toISOString(),
          modifiedDT: new Date().toISOString(),
        };

        if (existingIndex !== -1) {
          updatedValues[existingIndex] = newItem; // update existing
        } else {
          updatedValues.push(newItem); // add new if not found
        }

        return updatedValues;
      });

      setAmountPaybaleChange(false);
      setisSecondUseffectRun(true);
    }

    // Case 2: Non-zero amount, update or add "Current Addendum" item ( it is for edit view)
    if ((payableAmount !== '' && payableAmount !== '0') && amountPaybalecheck && amountPaybaleChange && isEditing) {
      formik.setValues((prevValues: any[]) => {
        const updatedValues = [...prevValues];

        const existingIndex = updatedValues.findIndex((item: any) =>
          item?.lst_PaymentType?.value?.includes(formikAddenda.values.addendaNbr)
        );

        const newItem = {
          ...(updatedValues[existingIndex] || {}), // preserve existing values if any
          projectId: prevValues[0]?.projectId || "",
          childId: addendaData?.result?.addendaId || null,
          orderId: (existingIndex !== -1
            ? updatedValues[existingIndex]?.orderId
            : updatedValues.length + 1),
          lst_PaymentType: {
            id: 14,
            value: `Upon Addenda Acceptance (${formikAddenda.values.addendaNbr?.includes("FLD")
              ? "Current Addendum"
              : formikAddenda.values.addendaNbr || "Current Addendum"
              })`,
          },
          id: "00000000-0000-0000-0000-000000000000",
          changeBy: payableAmount || 0,
          paymentAmt: 0,
          newAmount: payableAmount,
          lst_CreatedBy: prevValues[0]?.lst_CreatedBy || { id: null, value: "" },
          lst_Modified: { id: null, value: " " },
          createdDT: new Date().toISOString(),
          modifiedDT: new Date().toISOString(),
        };

        if (existingIndex !== -1) {
          updatedValues[existingIndex] = newItem; // update existing
        } else {
          updatedValues.push(newItem); // add new if not found
        }

        return updatedValues;
      });

      setAmountPaybaleChange(false);
      setisSecondUseffectRun(true);
    }
  }, [
    formikAddenda.values.amtPayableAcceptance,
    formikAddenda.values,
    amountPaybalecheck,
    amountPaybaleChange,
  ]);


  const isDuplicateOrderId = formik?.values?.length !== new Set(formik.values?.map((i: { orderId: any; }) => i?.orderId))?.size;
  const handleOrderIdChange = (index: number, newOrderId: number) => {
    const currentValues = [...formik.values];
    const movedItem = currentValues[index];

    // Remove item from its current position
    currentValues.splice(index, 1);

    // Insert at new position (newOrderId - 1 because array is 0-indexed)
    currentValues.splice(newOrderId - 1, 0, movedItem);

    // Reassign orderId based on new index
    const updatedValues = currentValues.map((item, i) => ({
      ...item,
      orderId: i + 1,
    }));

    formik.setValues(updatedValues);
  };
  const SaleAmount = Number(formikAddenda?.values?.saleAmount)

  const handleDeleteEntry = (orderIdToDelete: number) => {
    const updatedValues = formik.values.filter(
      (entry: any) => entry.orderId !== orderIdToDelete
    );
    const reordered = updatedValues.map((entry: any, index: number) => ({
      ...entry,
      orderId: index + 1,
    }));
    formik.setValues(reordered);
  };

  // for payment received 

  const totalAmount = formikAddenda?.values?.projectPaymentReceivableList?.projectPaymentReceivable?.reduce((sum: any, item: any) =>
    sum + (item?.amount || 0),
    0
  ) || 0

  const totalCount = formikAddenda?.values?.projectPaymentReceivableList?.projectPaymentReceivable?.reduce((sum: any, item: any) =>
    sum + 1,
    0
  ) || 0

  return (
    <>
      <div className='row mt-2 align-items-center'>
        <>
          <h5 className=''>Payment Schedule</h5>
          <div className='col-md-5'>

          </div>
          <div className='col-md-7'>
            <div className="col-md-12">
              <div className='d-flex justify-content-between'>
                <div className='input-label '>
                  Sale Price
                </div>
                <div className='br-gray w-50 text-end py-2 px-3 bg-gray payment-changeby '>
                  <FormattedNumber value={salePriceAddendaPrice?.salePrice} />
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className='d-flex justify-content-between'>
                <div className='input-label '>
                  Total Addenda Amount
                </div>
                <div className='br-gray w-50 text-end py-2 px-3 bg-gray payment-changeby '>
                  <FormattedNumber value={salePriceAddendaPrice?.addendaPrice} />
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className='d-flex justify-content-between'>
                <div className='input-label '>
                  Total Contract Amount
                </div>
                <div className='br-gray w-50 text-end py-2 px-3 bg-gray payment-changeby '>
                  {statusOfAddenda === "Approved" ?
                    <FormattedNumber value={totalContractInApproved} />
                    : <FormattedNumber value={totalContractAmount} />
                  }
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="col-md-12">
                <div className='d-flex justify-content-between'>
                  <div className='input-label '>
                    {`Current (${formikAddenda?.values?.addendaNbr ? formikAddenda?.values?.addendaNbr : 'Addendum'}) Amount`}
                  </div>
                  <div className='br-gray w-50 text-end py-2 px-3 bg-gray payment-changeby '>
                    <FormattedNumber value={SaleAmount} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className='d-flex justify-content-between'>
                <div className='input-label '>
                  Total Payment Distribution
                </div>
                <div className='br-gray w-50 text-end py-2 px-3 bg-gray payment-changeby '>
                  <FormattedNumber value={totalPaymentDistribution} />
                </div>
              </div>
            </div>
            <div className='col-md-12'></div>
            <div className="col-md-12 w-100 d-flex justify-content-end text-end ">
              <div className='br-gray px-3 py-2 w-50 payment-changeby '>
                <p className='color-red fs-15 fw-600'>{
                  <FormattedNumber value={formatedRemainingAmount} />
                }</p>
              </div>
            </div>
            {parseFloat(remainingAmount.replace(/,/g, '')) < 0 && (
              <p className="color-red fw-semibold d-flex justify-content-end">
                Negative amount not considered
              </p>
            )}
          </div>
          {isDuplicateOrderId &&
            <p className="color-red">
              Order Id's cant be same
            </p>}
          {/* <div className='col-md-2'>
          <div className='d-flex justify-content-center mt-4'>
            <button className='btn btn-primary py-2'>Recalculate</button>
          </div>
        </div> */}
          {/* table */}
          <div className='col-md-12 '>
            <div className="table-responsive mt-2 overflow-auto" style={{ height: '49vh' }}>
              <table className="table dataTable no-footer table-hover">
                <thead>
                  <tr>
                    <th className="p-0">
                      Order
                    </th>
                    <th className="p-0 px-3">
                      Payment Type
                    </th>
                    <th className="p-0">
                      Payment Amt
                    </th>
                    <th className="p-0 px-3">
                      Change By
                    </th>
                    <th className="p-0">
                      New Amount
                    </th>
                  </tr>
                </thead>
                {isLoading ? (
                  <tr>
                    <td colSpan={5} className="text-center">Loading...</td>
                  </tr>
                ) : formik?.values?.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center">No data found</td>
                  </tr>
                ) : (
                  <tbody>
                    {formik?.values?.map((item: any, index: any) => {
                      const selectedOption = optionsOrderId.find(
                        (option) => option.value === item.orderId
                      );
                      return (
                        <tr key={`${item.id}-${index}`} className={`${item?.id === '00000000-0000-0000-0000-000000000000' ? 'selected-row' : ''}`}>
                          <Select
                            styles={customStyles}
                            className="select payment-select p-0"
                            options={optionsOrderId}
                            value={selectedOption || null}
                            menuPlacement="top"
                            menuPosition="fixed"

                            // onChange={(selectedOption: any) => {
                            //   formik.setFieldValue(`[${index}].orderId`, selectedOption?.value || "");
                            // }}
                            onChange={(selectedOption: any) => {
                              if (selectedOption?.value) {
                                handleOrderIdChange(index, selectedOption.value);
                              }
                            }}
                          />
                          <td className="p-0 px-3" style={{ maxWidth: '430px', overflow: "auto" }}>{item.lst_PaymentType?.value}</td>
                          <td className="p-0 px-3" >
                            {/* {isEditing ? */}
                            <FormattedNumber value={item?.paymentAmt} />
                            {/* :
                              <FormattedNumber value={formik.values[index]?.newAmount} />
                            } */}
                          </td>
                          <td className="p-0" >
                            <input
                              type="text"
                              className="form-control payment-changeby text-end"
                              maxLength={20}
                              // value={isEditing ? formik.values?.[index]?.changeBy === 0 ? "" : formik.values?.[index]?.changeBy ?? "" : customOnChange[index] ?? ""}
                              value={formik.values?.[index]?.changeBy === 0 ? "" : formik.values?.[index]?.changeBy ?? ""}
                              onChange={(e) => {
                                const rawInput = e.target.value.replace(/,/g, "");

                                // Allow only valid number strings (or empty or -)
                                if (/^-?\d*\.?\d*$/.test(rawInput) || rawInput === "-" || rawInput === "") {
                                  // Always set the rawInput in Formik, even if it's empty
                                  formik.setFieldValue(`[${index}].changeBy`, rawInput);
                                  // handleCustomChange(index, rawInput);

                                  // If it's a valid number, update the calculated fields
                                  if (rawInput !== "" && rawInput !== "-") {
                                    const numericValue = Number(rawInput);
                                    const paymentAmt = Number(formik.values?.[index]?.paymentAmt) || 0;

                                    formik.setFieldValue(`[${index}].orderId`, item.orderId);
                                    formik.setFieldValue(`[${index}].lst_PaymentType.id`, item.lst_PaymentType?.id);
                                    formik.setFieldValue(`[${index}].newAmount`, numericValue + paymentAmt);
                                  } else {
                                    // Optionally clear `newAmount` or set to original paymentAmt
                                    formik.setFieldValue(`[${index}].newAmount`, formik.values?.[index]?.paymentAmt || 0);
                                  }
                                }
                              }}
                              onBlur={(e) => {
                                const rawVal = e.target.value.replace(/,/g, "");
                                const finalValue = rawVal && !isNaN(Number(rawVal)) ? Number(rawVal) : "";

                                // Always set final value (empty string or number)
                                formik.setFieldValue(`[${index}].changeBy`, finalValue);
                              }}
                              disabled={viewOnly || isReviewed || isApproved || (item.lst_PaymentType?.id === 14 && item.id === "00000000-0000-0000-0000-000000000000")}
                            />
                          </td>
                          <td className='p-0 px-3'>
                            <FormattedNumber value={formik.values[index]?.newAmount} />
                          </td>
                          <td className="p-0">
                            {item.id === "00000000-0000-0000-0000-000000000000" && item.lst_PaymentType?.id !== 14 && (
                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={() => handleDeleteEntry(item.orderId)}
                              >
                                {svgIcons.DeleteIcon}
                              </button>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                )
                }
              </table>
            </div>
          </div>
          {/* new table row */}
          <h6 className='mt-2 mb-1'>Add New Payment</h6>
          <div className='d-flex gap-2 '>
            <div className="col-md-1">
              <Select
                styles={customStyles}
                className="select payment-select"
                options={optionsOrderId}
                value={maxOrderId ? { label: `${maxOrderId}`, value: maxOrderId } : null}
                menuPlacement="top"
                menuPosition="fixed"
                isDisabled
              // onChange={(selectedOption: any) => {
              //   formik.setFieldValue(`[${index}].orderId`, selectedOption?.value || "");
              // }}
              />
            </div>
            <div className="col-md-4 mb-3">
              {/* <label className="input-label">
                Select a Type
              </label> */}
              <Select
                styles={customStyles}
                className="select payment-select"
                options={projectLookups?.result?.Lst_PaymentSchedule?.map((option: any) => ({
                  label: option?.value,
                  value: option?.id,
                }))}
                value={
                  paymentType.id
                    ? { label: paymentType.value, value: paymentType.id }
                    : null
                }
                onChange={(selectedOption: any) => {
                  setPaymentType({ id: selectedOption.value, value: selectedOption.label });
                }}
                isDisabled={viewOnly || isReviewed || isApproved}
                menuPlacement="top"

              />
            </div>
            <div className="col-md-4  mb-3">
              <div className='d-flex gap-3 align-items-end'>
                <p className='mb-0'>

                </p>
                <div className="form-wrap w-100 d-flex align-items-center mb-0">
                  <p className='mb-0'>$</p>
                  <div className='w-100'>
                    <TextField
                      type="text"
                      fieldClass='text-end payment-changeby'
                      value={paymentAmt}
                      // onChange={(e) => {
                      //   const amount = parseFloat(e.target.value) || 0;
                      //   setPaymentAmt(amount.toString());
                      // }}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^-?\d*\.?\d*$/.test(val) || val === '' || val === '-') {
                          setPaymentAmt(val);
                        }
                      }}
                      disabled={viewOnly || isReviewed || isApproved}
                    />
                    {/* <NumberField
                     type="text"
                     fieldClass="text-end"
                     required
                     min={0}
                     value={paymentAmt}
                     onChange={(e) => {
                      const amount = parseFloat(e.target.value) || 0;
                      setPaymentAmt(amount.toString());
                    }}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-2 mb-3'>
              <div className='d-flex justify-content-center gap-2 '>
                <button className='btn btn-primary px-2 py-2 payment-changeby' onClick={handleTableChange}
                  disabled={
                    paymentType?.id === 0 &&
                    !paymentAmt ||
                    remainingAmount === '0'
                  }
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          {(paymentType?.value === "Other" || paymentType?.value === "On Date") && (
            <>
              <div className="row">
                <div className="col-md-1">

                </div>
                <div className="col-md-9 ms-2 " style={{ width: '688px' }}>
                  <div className="mb-2">
                    <label>Description <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={paymentDescription}
                      onChange={(e) => { setPaymentDescription(e.target.value); setConcatPaymentDescription(prev => `${paymentDescription}-${paymentDate}`.trim()) }}
                      placeholder="Enter description"
                    />
                  </div>
                </div>
              </div>

            </>
          )}
          {paymentType?.value === "On Date" && (
            <>
              <div className="row">
                <div className="col-md-1">

                </div>
                <div className="col-md-9 ms-2 " style={{ width: '688px' }}>
                  <label>Date <span className="text-danger">*</span></label>
                  <div className="form-wrap icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                      className="form-control datetimepicker deals-details"
                      onChange={(date) => {
                        if (date) {
                          const selected = dayjs(date);
                          setPaymentDate(selected); // set actual date in date state
                          // Append formatted date to description
                          const formattedDate = selected?.format("MMM-DD-YYYY");
                          setConcatPaymentDescription(prev => `${paymentDescription} - ${formattedDate}`.trim());
                        }
                      }}
                      value={paymentDate || null} // fallback to current date
                      format="MMM-DD-YYYY"
                      disabled={isReviewed || isApproved || viewOnly}
                      allowClear={false}
                    />
                  </div>
                </div>
              </div>

            </>
          )}
          <div>
            <h5 className="mb-3">
              Payments Received
            </h5>
            <div>
              <div className='row mb-3'>
                <div className='col-md-8'>
                  {/* table  */}
                  <div className='d-flex'>
                    <div className='w-35'>
                      <p className='mb-0'>Last Timberline Sync: </p>
                    </div>
                    <div>
                      <DateTimeComp formattedDate={formikAddenda?.values?.projectPaymentReceivableList?.lstTimberLineSync} />
                    </div>
                  </div>
                  <div className='d-flex'>
                    <div className='w-35'>
                      <p className='mb-0'>Last AP entry in Timberline:</p>
                    </div>
                    <div>
                      <DateTimeComp formattedDate={formikAddenda?.values?.projectPaymentReceivableList?.lstApEntryInTimberLine} />
                    </div>
                  </div>
                  <div className="table-responsive mt-2 overflow-auto saleInfoTableHeight">
                    <table className="table datanew dataTable no-footer table-hover">
                      <thead>
                        <tr>
                          <th>
                            Date
                          </th>
                          <th>
                            Payment Description
                          </th>
                          <th className='text-end'>
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formikAddenda?.values?.projectPaymentReceivableList?.projectPaymentReceivable?.map((item: any, index: any) => (
                          <tr key={item.id}>
                            <td><DateComp formattedDate={new Date(item?.transcationDate).toLocaleDateString()} /></td>
                            <td>{item?.description}</td>
                            <td className='text-end'>
                              <FormattedNumber value={item.amount} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className='row'>
                    <div className='col-md-5 pt-4 text-end'>
                      <h6 className='color-red'> Count : {totalCount} </h6>
                    </div>
                    <div className='col-md-7 pt-4 text-end '>
                      <h6 className='color-red mr-15'><FormattedNumber value={totalAmount} /></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div >
    </>

  )
}

export default PaymentScheduleAddenda